<template>
    <v-menu
        v-model="dateRangePickerOpen"
        :close-on-content-click="false"
        location="bottom start"
    >
        <template #activator="{ props: dateRangePickerActivatorProps }">
            <AppTextField
                v-bind="{ ...attrs, ...dateRangePickerActivatorProps }"
                class="picker-control"
                :model-value="formattedDateRange"
                :placeholder="placeholder"
                :name="name"
                :width="width"
                :disabled="disabled"
                :readonly="true"
                :clearable="clearable"
                :hide-details="hideDetails"
                :density="density"
                prepend-inner-icon="mdi-calendar-blank-outline"
                @update:model-value="setClearedDateRange"
            />
        </template>

        <v-card
            class="date-range-field__picker"
            rounded="lg"
        >
            <v-date-picker
                color="primary"
                hide-header
                :model-value="modelValue"
                multiple="range"
                @update:model-value="setSelectedDateRange"
            />
        </v-card>
    </v-menu>
</template>

<script setup>
import { computed, ref, useAttrs } from 'vue'

import AppTextField from './AppTextField.vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },

  placeholder: {
    type: String,
    default: '',
  },

  name: {
    type: String,
    default: '',
  },

  width: {
    type: [String, Number],
    default: '100%',
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  clearable: {
    type: Boolean,
    default: true,
  },

  hideDetails: {
    type: [Boolean, String],
    default: 'auto',
  },

  density: {
    type: String,
    default: 'compact',
    validator: (value) => ['default', 'comfortable', 'compact'].includes(value),
  },
})

const emit = defineEmits(['update:modelValue'])
const attrs = useAttrs()
const dateRangePickerOpen = ref(false)

const formattedDateRange = computed(() => {
  const fromDate = props.modelValue[0]
  const toDate = props.modelValue.length > 1 ? props.modelValue[props.modelValue.length - 1] : null

  if (!fromDate) {
    return ''
  }

  return `${formatDisplayDate(fromDate)} - ${toDate ? formatDisplayDate(toDate) : ''}`
})

function setSelectedDateRange (dateRange) {
  emit('update:modelValue', dateRange)

  if (dateRange.length > 1) {
    dateRangePickerOpen.value = false
  }
}

function setClearedDateRange (value) {
  if (!value) {
    emit('update:modelValue', [])
  }
}

function formatDisplayDate (date) {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')

  return `${day}.${month}.${date.getFullYear()}`
}
</script>

<style
    scoped
    lang="scss"
>
.date-range-field {
    &__picker {
        overflow: hidden;
    }
}
</style>
